export default __webpack_public_path__ + "static/media/rnr-sports-table-5.060fe97e.webp";